import { Modal } from '@procurify/ui'

export interface IScaVerificationModalProps {
  open: boolean

  onClose: () => void
}

export const ScaVerificationModal = ({
  open,
  onClose,
}: IScaVerificationModalProps) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Modal.Card>
        <Modal.Header onClose={onClose} />

        <Modal.Content minHeight={300}>
          <div id='sca-component-mount' />
        </Modal.Content>
      </Modal.Card>
    </Modal>
  )
}
